"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enum = require("../enum");
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _api = require("../api");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_COVER_SIZE = 200 * 1024;
var MAX_COVER_SIZE_ERROR = '图片大小不能超过200KB';
var _default = exports.default = {
  name: 'PageJumpDialog',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      title: '新增分享文案',
      pageTypeEnum: _enum.pageTypeEnum,
      form: {
        pageType: null,
        shareText: '',
        coverImage: '',
        appScope: 0,
        appIds: [],
        isOpen: 0,
        status: 0
      },
      rules: {
        pageType: [{
          required: true,
          message: '请选择页面类型',
          trigger: 'change'
        }],
        shareText: [{
          required: true,
          message: '请输入分享文案',
          trigger: 'blur'
        }],
        appIds: [{
          required: true,
          message: '请选择小程序',
          trigger: 'change'
        }]
      },
      appOptions: [],
      placeholderList: []
    };
  },
  computed: {
    showProductName: function showProductName() {
      // 商品详情页：2普通 / 13团购 / 16酒店 / 19外卖(暂未开放)
      return [2, 13, 16, 19].includes(this.form.pageType);
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.initData();
        this.loadPlaceholders();
      }
    }
  },
  created: function created() {
    this.loadAppOptions();
  },
  methods: {
    initData: function initData() {
      var _this = this;
      if (this.data) {
        this.title = '编辑分享文案';
        this.form = {
          pageType: this.data.pageType,
          shareText: this.data.shareText || '',
          coverImage: this.data.coverImage || '',
          appScope: this.data.appScope != null ? this.data.appScope : 0,
          appIds: this.data.appIds || [],
          isOpen: this.data.isOpen,
          status: this.data.status
        };
      } else {
        this.title = '新增分享文案';
        this.form = {
          pageType: null,
          shareText: '',
          coverImage: '',
          appScope: 0,
          appIds: [],
          isOpen: 0,
          status: 0
        };
      }
      this.$nextTick(function () {
        _this.$refs.formRef && _this.$refs.formRef.clearValidate();
      });
    },
    loadAppOptions: function () {
      var _loadAppOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return companyappApi.companyappAutoListApi();
            case 1:
              res = _context.v;
              this.appOptions = (res || []).map(function (v) {
                return {
                  label: v.appName,
                  value: v.id
                };
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function loadAppOptions() {
        return _loadAppOptions.apply(this, arguments);
      }
      return loadAppOptions;
    }(),
    modalPicTap: function modalPicTap() {
      var _this2 = this;
      this.$modalUpload(function (res) {
        if (!res || !res[0]) return;
        var url = res[0].attDir || res[0].sattDir || res[0].url || '';
        if (!url) return;
        _this2.form.coverImage = url;
        _this2.$refs.formRef && _this2.$refs.formRef.validateField('coverImage');
      }, '1', 'system', true, {
        maxSizeKB: MAX_COVER_SIZE,
        maxSizeErrorMsg: MAX_COVER_SIZE_ERROR
      });
    },
    removeCoverImg: function removeCoverImg() {
      this.form.coverImage = '';
      this.$refs.formRef && this.$refs.formRef.validateField('coverImage');
    },
    loadPlaceholders: function () {
      var _loadPlaceholders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _api.pageJumpPlaceholdersApi)();
            case 1:
              res = _context2.v;
              this.placeholderList = res || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadPlaceholders() {
        return _loadPlaceholders.apply(this, arguments);
      }
      return loadPlaceholders;
    }(),
    insertPlaceholder: function insertPlaceholder(label) {
      var item = this.placeholderList.find(function (v) {
        return v.label === label;
      });
      var text = item ? item.placeholder : '';
      if (!text) return;
      this.form.shareText += text;
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        var submitData = {
          pageType: _this3.form.pageType,
          shareText: _this3.form.shareText,
          coverImage: _this3.form.coverImage,
          appScope: _this3.form.appScope,
          isOpen: _this3.form.isOpen,
          status: _this3.form.status
        };
        if (_this3.form.appScope === 1) {
          submitData.appIds = _this3.form.appIds;
        }
        if (_this3.data) {
          submitData.id = _this3.data.id;
        }
        _this3.$emit('submit', submitData);
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    }
  }
};